module.exports = __webpack_public_path__ + "static/img/16_sad.65e34793.jpg";